import { HttpErrorResponse } from '@angular/common/http';

import { LogModel } from '../../core/models';
import { GenerateReportRequest } from '../../core/models/generate-report-request.model';
import { TripReport } from '../../core/models/trip-report.model';
import { ReportExportType } from '../../shared/enums/report-export-type.enum';
import { ReportType } from '../../shared/enums/report-type.enum';

const ActionTypes = {
  LOAD_LAST_LOGS: `[Log] Load Last Logs`,
  LOAD_LAST_LOGS_SUCCESS: `[Log] Load Last Logs Success`,
  LOAD_LAST_LOGS_FAIL: `[Log] Load Last Logs Fail`,

  LOAD_VEHICLE_LOGS: `[Log] Load Vehicle logs`,
  LOAD_VEHICLE_LOGS_SUCCESS: `[Log] Load Vehicle Logs Success`,
  LOAD_VEHICLE_LOGS_FAIL: `[Log] Load Vehicle Logs Fail`,

  SET_INACTIVE_VEHICLES_LOGS: `[Log] Set Inactive Vehicles Logs`,

  CLEAR_OLD_LOGS: `[Log] Clear Old Logs`,

  GENERATE_REPORT: `[Log] Generate Report`,
  GENERATE_REPORT_SUCCESS: `[Log] Generate Report Success`,
  GENERATE_REPORT_FAIL: `[Log] Generate Report Fail`,

  RESET_LOG_STATE: `[Log] Reset Log State`,
};

export class LoadLastLogsAction {
  static type = ActionTypes.LOAD_LAST_LOGS;
}

export class LoadLastLogsSuccessAction {
  static type = ActionTypes.LOAD_LAST_LOGS_SUCCESS;

  constructor(public payload: LogModel[]) {
  }
}

export class LoadLastLogsFailAction {
  static type = ActionTypes.LOAD_LAST_LOGS_FAIL;

  constructor(public payload: HttpErrorResponse) {
  }
}




export class LoadVehicleLogsAction {
  static type = ActionTypes.LOAD_VEHICLE_LOGS;

  constructor(
    public payload: {
      fromdate?: string;
      todate?: string;
      take?: number;
      vehicleId: number
    },
  ) {
  }
}

export class LoadVehicleLogsSuccessAction {
  static type = ActionTypes.LOAD_VEHICLE_LOGS_SUCCESS;

  constructor(public payload: LogModel[]) {
  }
}

export class LoadVehicleLogsFailAction {
  static type = ActionTypes.LOAD_VEHICLE_LOGS_FAIL;

  constructor(public payload: HttpErrorResponse) {
  }
}




export class SetInactiveVehiclesLogsAction {
  static type = ActionTypes.SET_INACTIVE_VEHICLES_LOGS;

  constructor(public payload: LogModel[]) {
  }
}




export class ClearOldLogsAction {
  static type = ActionTypes.CLEAR_OLD_LOGS;
}




export class GenerateReportAction {
  static type = ActionTypes.GENERATE_REPORT;

  constructor(public payload: GenerateReportRequest) {
  }
}

export type ReportResponseItem = {
  tripDate: Date;
  items: TripReport[];
};

export type ReportPayload = {
  exportType: ReportExportType,
  response: ArrayBuffer,
  reportType: ReportType,
}

export class GenerateReportSuccessAction {
  static type = ActionTypes.GENERATE_REPORT_SUCCESS;

  constructor(
    public payload: ReportPayload
  ) {
  }
}

export class GenerateReportFailAction {
  static type = ActionTypes.GENERATE_REPORT_FAIL;

  constructor(public payload: HttpErrorResponse) {
  }
}




export class ResetLogStateAction {
  static type = ActionTypes.RESET_LOG_STATE;
}
